import { breakpoints, Button, Dialog } from '@etg/wings';
import { css, cx, getTextStyles } from '@eti/styles';
import { variants, DangerousHtmlContent } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { useEffect } from 'react';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import DialogIllustration from './DialogIllustration';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const buttonsWrapperStyles = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  @media (min-width: ${breakpoints._970}) {
    flex-direction: row;
  }
`;
const buttonClass = css`
  flex: 1 0 auto;
`;
const ProductModal = ({
  buttonType = variants.PRIMARY,
  confirmText,
  content,
  declineText,
  isOpen,
  onConfirm,
  onDecline,
  productName,
  title
}) => {
  const {
    t
  } = useTranslation();
  const {
    sendPopupViewEvent
  } = useProductSnowplowTracking(productName);
  useEffect(() => {
    if (isOpen) {
      sendPopupViewEvent();
    }
    // oxlint-disable-next-line react/exhaustive-deps
  }, [isOpen]);
  return /*#__PURE__*/_jsx(Dialog, {
    closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
    footer: /*#__PURE__*/_jsxs("div", {
      className: buttonsWrapperStyles,
      children: [/*#__PURE__*/_jsx(Button, {
        className: buttonClass,
        "data-testid": `${productName}Modal-decline-button`,
        onClick: onDecline,
        variant: variants.SECONDARY,
        children: /*#__PURE__*/_jsx(DangerousHtmlContent, {
          component: "span",
          content: declineText || t('Product.Persuasion.Label.Decline')
        })
      }), /*#__PURE__*/_jsx(Button, {
        className: buttonClass,
        "data-testid": `${productName}Modal-confirm-button`,
        onClick: onConfirm,
        variant: buttonType,
        children: /*#__PURE__*/_jsx(DangerousHtmlContent, {
          component: "span",
          content: confirmText || t('Product.Persuasion.Label.Confirm')
        })
      })]
    }),
    illustration: /*#__PURE__*/_jsx(DialogIllustration, {
      productName: productName
    }),
    isOpen: isOpen !== null && isOpen !== void 0 ? isOpen : false,
    title: title,
    children: /*#__PURE__*/_jsx(DangerousHtmlContent, {
      className: cx('etiModal__content', getTextStyles()),
      content: content,
      "data-testid": `${productName}-dialog-content`
    })
  });
};
export default ProductModal;
//# sourceMappingURL=ProductModal.js.map